<template>
  <span
    v-if="client.language_id && client.language"
    class="label tag-language table-tag-content"
    >{{ client.language.name
    }}<a @click.prevent="$emit('delete')"
      ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
  ></span>
</template>

<script>
export default {
  name: "Language",
  props: {
    client: {
      type: Object,
      required: true
    },

    showRemove: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.tag-language {
  /*background-color: #bdbdbd;*/
  /*font-size: 12px;*/
  /*color: black;*/
  /*margin: 2px;*/
  /*line-height: 2;*/
  /*padding: 4px;*/
  /*cursor: pointer;*/
  /*font-family: Montserrat;*/
  background-color: #bdbdbd;
  font-size: 11px;
  /*  color: black;*/
  /*  margin: 1px;*/
  /*  font-weight: 400;*/
  /*  text-transform: uppercase;*/
  /*  line-height: 2;*/
  /*  padding: 4px;*/
  /*  cursor: pointer;*/
  /*  font-family: Montserrat;*/
}

.remove-tag-icon {
  color: black;
  cursor: pointer;
  margin-left: 5px;
}

.remove-tag-icon:hover {
  color: #f44336;
}
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.table-tag-content {
  min-width: 38px !important;
  line-height: 3 !important;
}
</style>
